import React, { useState, useEffect } from 'react'
import { Outlet,useLocation, useParams, useLoaderData } from "react-router-dom";
import { PageLoader } from '../../common';
import NotFound from '../../common/ErrorPages/NotFound';
import { BsesApiService } from '../ApiService/BsesService';
import { Card, Input , Button} from 'antd';
import ConsumerPaymentCard from './consumerPaymentCard';

const CheckVendorBses = () => {

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [consumerData, setCustomerData] = useState({})
    const [showPaymentOptions, setPaymentOptions] = useState(false)
    let { region } = useParams();
    const data = useLoaderData()

    useEffect(() => {
        getCustomerDetails()
    }, []);

    const getCustomerDetails = async () =>{
        try{
            const queryParamsObject = {};
            for (const [key, value] of queryParams.entries()) {
                queryParamsObject[key] = value;
            }
            queryParamsObject.region = region
            const response = data
            if  (response.status){
                setCustomerData(response.data)
                setPaymentOptions(response.show_payment_options)
                setSuccess(true)
            }
            else{
                setError(true)
            }
        }
        catch(error){
            console.log("in Catch",error)
        }
        setLoader(false)
    }

    const renderCard = () =>{
        return <ConsumerPaymentCard consumerData={consumerData} showPaymentOptions={showPaymentOptions} />
    }

    if (success){
        return(
            <>
            {renderCard()}
        </>
        )
    }
    if (!loader && error) {
        return <NotFound />;
    }
    if (loader) {
        return <PageLoader />
    }
}

const getBsesCustomerDetails = async ({params}) => {
    let response = {
        success: false
    }
    const queryString = window.location.search;
    const queryParams1 = new URLSearchParams(queryString)
    const queryParamsObject = {};
    for (const [key, value] of queryParams1.entries()) {
        queryParamsObject[key] = value;
    }
    queryParamsObject.region = params.region
    if (queryParamsObject){
        response = await BsesApiService.getCustomerDetails(queryParamsObject)
    }
    return response
}

export {CheckVendorBses, getBsesCustomerDetails}
